import React from 'react';
import Typography from '@material-ui/core/Typography';
import './agent-review.css';
import PropTypes from 'prop-types';
import { numberFormat, maskAccount } from '../../constants/constants';
import InfoMessageBar from '../common/info-message/info-message';
import Title from '../common/custom-components/customTitleHeader';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import CancelDialog from '../common/cancel-dialog/cancel-dialog';
import Divider from '@material-ui/core/Divider';
import Link from '@material-ui/core/Link';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ArrowDropDownCircleIcon from '@material-ui/icons/ArrowDropDownCircle';

const AgentReviewForm = props => {
  console.log('Summary-Page', props);
  let DueDate =
    props.customerInfo.depositDueDate !== null &&
    props.customerInfo.depositDueDate !== undefined
      ? moment(props.customerInfo.depositDueDate).format('MM-DD-YYYY')
      : 'Pending';
  return (
    <div className="container" style={{ backgroundColor: '#F7F8F9' }}>
      <div className="row">
        <div className="col-md-6 offset-md-3 col-xs-12">
          <Card boxShadow={3}>
            <div className="header1">
              <Title text="Application Summary" />
            </div>
            {props.errors && (
              <InfoMessageBar variant="error" message={props.errors} />
            )}
            <CardContent>
              <div className="content-Header-pad">
                <div className="header">
                  <div className="header-flex">
                    <Typography component="h6" variant="h5">
                      Account Information
                    </Typography>
                  </div>

                  <div>
                    <ArrowDropDownCircleIcon color="primary" />
                  </div>
                </div>
              </div>

              <Divider />
              <div className="content-pad">
                <Typography component="h2" variant="h5">
                  Company Name :
                </Typography>
                {props &&
                  props.customerInfo &&
                  props.customerInfo.companyName !== undefined && (
                    <Typography color="textSecondary" variant="h6">
                      {props.customerInfo.companyName}
                    </Typography>
                  )}
              </div>

              <div className="content-pad">
                <Typography component="h2" variant="h5">
                  Account Number:
                </Typography>
                {props &&
                  props.customerInfo &&
                  props.customerInfo.billAccount !== undefined && (
                    <Typography color="textSecondary" variant="h6">
                      {maskAccount(props.customerInfo.billAccount, 5)}
                    </Typography>
                  )}
              </div>

              <div className="content-pad">
                <Typography component="h2" variant="h5">
                  TaxID/SSN :
                </Typography>
                {props &&
                  props.customerInfo &&
                  props.customerInfo.taxId !== undefined && (
                    <Typography color="textSecondary" variant="h6">
                      {maskAccount(props.customerInfo.taxId, 4)}
                    </Typography>
                  )}
              </div>
              <div className="content-Header-pad">
                <Typography component="h2" variant="h5">
                  Deposit Due Date :
                </Typography>
                <Typography color="textSecondary" variant="h6">
                  {DueDate}
                </Typography>
              </div>
              <Divider />
              <div className="content-Header-pad">
                <Typography component="h2" variant="h5">
                  Deposit Quote Amount :
                </Typography>
                {props &&
                  props.customerInfo &&
                  props.customerInfo.depositQuoteAmt !== undefined && (
                    <Typography color="textSecondary" variant="h6">
                      {numberFormat(props.customerInfo.depositQuoteAmt)}
                    </Typography>
                  )}
              </div>

              <Divider />
              <div className="content-pad">
                <Typography component="h2" variant="h5">
                  Service Address :
                </Typography>
                {props &&
                  props.customerInfo &&
                  props.customerInfo.street !== undefined && (
                    <Typography
                      color="textSecondary"
                      variant="h6"
                      display="inline"
                    >
                      {props.customerInfo.street}{' '}
                      {props.customerInfo.streetline2}
                      <br />
                      {props.customerInfo.city} {props.customerInfo.state}{' '}
                      {props.customerInfo.zipCode}
                    </Typography>
                  )}
              </div>
            </CardContent>
          </Card>
          <Card boxShadow={3} style={{ marginTop: 40 }}>
            <CardContent>
              <div className="content-Header-pad">
                <Typography component="h6" variant="h5">
                  Bond Information
                </Typography>
              </div>
              <Divider />

              {props && props.customerInfo.bondNumber !== undefined && (
                <div className="content-Header-pad">
                  <Typography component="h2" variant="h5">
                    Bond # :
                  </Typography>
                  {props && props.customerInfo.bondNumber !== undefined && (
                    <Typography color="textSecondary" variant="h6">
                      {props.customerInfo.bondNumber.toUpperCase()}
                    </Typography>
                  )}
                </div>
              )}
              <Divider />
              {props && props.customerInfo.depositBondAmt !== undefined && (
                <div className="content-Header-pad">
                  <Typography component="h2" variant="h5">
                    Bond Amount :
                  </Typography>
                  {props && props.customerInfo.depositBondAmt !== undefined && (
                    <Typography color="textSecondary" variant="h6">
                      {numberFormat(props.customerInfo.depositBondAmt)}
                    </Typography>
                  )}
                </div>
              )}
              <Divider />
              <div className="content-Header-pad">
                <Typography component="h2" variant="h5">
                  Insurance Company :
                </Typography>
                {props &&
                  props.customerInfo &&
                  props.customerInfo.insuranceCompanyName !== undefined && (
                    <Typography color="textSecondary" variant="h6">
                      {props.customerInfo.insuranceCompanyName}
                    </Typography>
                  )}
              </div>
              <Divider />
              <div className="content-Header-pad">
                <Typography component="h2" variant="h5">
                  Mailing Address:
                </Typography>
                {props &&
                  props.customerInfo &&
                  props.customerInfo.insuranceCompanyStrAddr !== undefined && (
                    <Typography color="textSecondary" variant="h6">
                      <span>
                        {' '}
                        {props.customerInfo.insuranceCompanyStrAddr}{' '}
                      </span>
                      <br />
                      <span>
                        {props.customerInfo.insuranceCompanyCity}{' '}
                        {props.customerInfo.insuranceCompanyState}{' '}
                        {props.customerInfo.insuranceCompanyZipCode}
                      </span>
                    </Typography>
                  )}
              </div>
              <Divider />
              <div className="botton1-group">
                <div className="link-pad">
                  <Link
                    component="button"
                    variant="h6"
                    color="primary"
                    style={{ padding: '15px 50px' }}
                    value={props.customerInfo.id}
                    onClick={props.handleAgentHomeCancel}
                  >
                    Delete Application
                  </Link>
                </div>
                <Button
                  className="btn-lg "
                  variant="contained"
                  color="primary"
                  type="submit"
                  onClick={props.handleReviewSubmit}
                  id="submit"
                  value={'true'}
                  align="center"
                  style={{
                    marginBottom: 15,
                    fontSize: 16,
                  }}
                  fullWidth
                  disabled={props.customerInfo.appStatus === 'REJECTED'}
                >
                  CONTINUE
                </Button>

                <CancelDialog
                  open={props.modalOpen}
                  delete={props.handleAppDelete}
                  close={props.handleModalClose}
                  content=""
                />

                <div className="link-pad">
                  <Link
                    component="button"
                    variant="h6"
                    color="primary"
                    onClick={props.handleReviewBack}
                    value={'false'}
                  >
                    BACK
                  </Link>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

AgentReviewForm.propTypes = {
  data: PropTypes.shape({
    bondNo: PropTypes.string,
    depositAmt: PropTypes.string,
    insurCity: PropTypes.string,
    insurState: PropTypes.string,
    insurStr: PropTypes.string,
    insurStr2: PropTypes.string,
    insurZipcode: PropTypes.string,
    insurcompanyName: PropTypes.string,
  }),
  customerInfo: PropTypes.shape({
    id: PropTypes.number,
    companyName: PropTypes.string,
    billAccount: PropTypes.number,
    depositBondAmt: PropTypes.number,
    depositQuoteAmt: PropTypes.number,
    bondNumber: PropTypes.string,
    taxId: PropTypes.number,
    street: PropTypes.string,
    streetline2: PropTypes.string,
    appStatus: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.number,
    depositDueDate: PropTypes.string,
    depositQuote: PropTypes.number,
    insuranceCompanyName: PropTypes.string,
    insuranceCompanyStrAddr: PropTypes.string,
    insuranceCompanyCity: PropTypes.string,
    insuranceCompanyState: PropTypes.string,
    insuranceCompanyZipCode: PropTypes.string,
  }),
  insuranceInfo: PropTypes.shape({
    insuranceCompanyName: PropTypes.string,
    insuranceCompanyStrAddr: PropTypes.string,
    insuranceCompanyCity: PropTypes.string,
    insuranceCompanyState: PropTypes.string,
    insuranceCompanyZipCode: PropTypes.string,
  }),
  handleReviewSubmit: PropTypes.func,
  handleReviewBack: PropTypes.func,
  handleAgentHomeCancel: PropTypes.func,
  handleModalClose: PropTypes.func,
  handleAppDelete: PropTypes.func,
  viewinfoPage: PropTypes.func,
  modalOpen: PropTypes.bool,
  errors: PropTypes.string,
};

export default AgentReviewForm;
